import { createContext, useContext } from 'react';
import type { Role } from './nav';

export type Session = {
  userId: string;
  email: string;
  name: string | null;
  orgId: string;
  role: Role;
};

const SessionContext = createContext<Session | null>(null);
export const SessionProvider = SessionContext.Provider;

export function useSession(): Session {
  const s = useContext(SessionContext);
  if (!s) throw new Error('useSession outside SessionProvider');
  return s;
}
